import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WorkerBuild } from '../../api/health';

/** One build in a few words: branch, short commit and build number, whichever are known. */
export const describeBuild = (build: WorkerBuild) =>
    [build.branch, build.commit?.slice(0, 8), build.buildNumber ? `#${build.buildNumber}` : null]
        .filter(Boolean)
        .join(' · ') || 'build onbekend';

const sameBuild = (a: WorkerBuild, b: WorkerBuild) =>
    describeBuild(a) === describeBuild(b);

/**
 * Which build the function apps run, as their instances report it: one line when they agree, otherwise one per app.
 * Says whether a fix is live at a customer without guessing from the deploy pipeline.
 */
export const BuildLine = ({ builds }: { builds?: WorkerBuild[] }) => {
    if (!builds || builds.length === 0) {
        return null;
    }

    const doubt = builds.some((build) => build.stale || build.mixed);
    const allSame = builds.every((build) => sameBuild(build, builds[0]));

    return (
        <p className="queue-board__note queue-board__note--build">
            <FontAwesomeIcon icon={doubt ? 'triangle-exclamation' : 'code-branch'} />
            <span>
                {allSame ? (
                    <>
                        Alle apps draaien <code>{describeBuild(builds[0])}</code>
                    </>
                ) : (
                    builds.map((build, index) => (
                        <span key={build.app}>
                            {index > 0 && ', '}
                            {build.app} <code>{describeBuild(build)}</code>
                        </span>
                    ))
                )}
                {builds.some((build) => build.mixed) && ' (instances draaien verschillende builds, een deploy loopt?)'}
                {builds.some((build) => build.stale) && ' (een melding is ouder dan een dag)'}
            </span>
        </p>
    );
};
